<template>
    <div>
        <DocumentTableContentTypeSelector v-if="totalItems !== 0"
            :contentTypes="generatedContentTypes"
            :prevSelectedContentType="prevSelectedContentType"
        />
        <DocumentTable v-if="!noDocumentsFound"
            :defaultVisibleFields="defaultVisibleFields"
            :unGroupedDocumentList="unGroupedDocumentList"
            :groupedDocumentList="groupedDocumentList"
            :selectedDocument="selectedDocument"
            :selectedDocuments="selectedDocuments"
            :latestCTVersionFields="latestCTVersionFields"
            v-on="$listeners"
        />
        <DocumentTablePagination v-if="!noDocumentsFound"
            ref="tablePagination"
            :pageSize="pageSize"
            :page="page"
            :totalItems="totalItems"
            @on-page-change="$emit('on-page-change', $event)"
        />
    </div>
</template>

<script>
import DocumentTable from './table/DocumentTable.vue';
import DocumentTableContentTypeSelector from './DocumentTableContentTypeSelector.vue';
import DocumentTablePagination from './DocumentTablePagination.vue';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
        DocumentTable,
        DocumentTableContentTypeSelector,
        DocumentTablePagination
    },
    props: {
        unGroupedDocumentList: {
            type: Array,
            default: () => []
        },
        groupedDocumentList: {
            type: Array,
            default: () => []
        },
        allDocumentList: {
            type: Array,
            default: () => []
        },
        defaultVisibleFields: {
            type: Number,
            default: 4
        },
        selectedDocument: Number,
        selectedDocuments: {
            type: Array,
            default: () => []
        },
        totalItems: {
            type: Number,
            default: 0
        },
        prevSelectedContentType: {
            type: String,
            default: null
        },
        page: Number,
        pageSize: Number,
        noDocumentsFound: {
            type: Boolean,
            default: false
        },
        latestCTVersionFields: {
            type: Array,
            required: true
        }
    },
    computed: {
        generatedContentTypes() {
            const allDocs = this.allDocumentList;

            const map = new Map();
            allDocs.forEach(doc => {
                const name = doc.ContentType;
                const baseName = Utils.mix.getContentTypeBaseName(name);
                if (!map.has(baseName)) {
                    map.set(baseName, { baseName, count: 0 });
                }
                map.get(baseName).count++;
            });
            const contentTypes = Array.from(map.values())
                .sort((a, b) => a.baseName.localeCompare(b.baseName, undefined, { sensitivity: 'base' }))
                .map(ct => ({
                    id: ct.baseName,
                    text: `${ct.baseName} (${ct.count})`
                }));

            return contentTypes;
        },
    },
    methods: {
        resetPagination() {
            if (this.$refs.tablePagination) this.$refs.tablePagination.resetPagination();
        }
    },
};
</script>